/**
 * engineNormalJson_Merge_Metadata.ts - Metadata utilities for EngineNormalJson
 * Pure ES Module version
 */

import { JsonObject } from '../../../../Assembler/dist/app/json/jsonValue.js';
import { GenerateHtmlJson } from '../../base/loader/generateHtmlJson.js';
import { META_KEY } from './engineNormalJson_Merge_Constants.js';

/**
 * Tries to return static HTML if the template has no dynamic content
 * Uses _meta to check for presence of dynamic elements in O(1) time
 */
export function tryReturnStaticHtml(htmlJson: JsonObject): { success: boolean; staticHtml: string } {
    const result = { success: false, staticHtml: '' };

    if (htmlJson && htmlJson.has(META_KEY)) {
        const metaValue = htmlJson.get(META_KEY);
        const metaObj = metaValue.asObject();
        if (metaObj) {
            const hasPlaceholders = metaObj.get('hasPlaceholders').asBool();
            const hasSlotholders = metaObj.get('hasSlotholders').asBool();
            const hasArrayBlocks = metaObj.get('hasArrayBlocks').asBool();
            const hasJsonKeys = metaObj.get('hasJsonKeys').asBool();

            // If none of the dynamic flags are true, we can return static HTML
            if (!hasPlaceholders && !hasSlotholders && !hasArrayBlocks && !hasJsonKeys) {
                // Also check for conditional entries (TYPE_CONDITIONAL = 'c') directly in the htmlJson keys
                for (const key of htmlJson.keys()) {
                    if (key.length > 0 && key[0] === 'c') {
                        return result; // Has conditional - not static
                    }
                }

                result.staticHtml = GenerateHtmlJson.convertJsonToHtml(htmlJson);
                result.success = true;
            }
        }
    }

    return result;
}
